import React from "react"
import PropTypes from "prop-types"

const Cyberstalking = ({ fillColor, width, height }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 99.01 80.71"
    width={width}
    height={height}
  >
    <path
      fill="#56a8de"
      d="M55.5,14.85c-.53,.08-1.03,.23-1.51,.43,1.93,.16,3.87,.31,5.8,.48-3.07-5.01-6.2-9.97-9.49-14.8-.98-1.44-2.88-1.08-3.68,.04-.28,.19-.54,.46-.76,.81-2.83,4.49-5.58,9.04-8.32,13.59,2.24-.99,4.61-1.67,7.06-2,1.3-2.19,2.6-4.37,3.87-6.57,1.19,2.22,2.43,4.41,3.68,6.59,1.13,.05,2.25,.22,3.33,.54,.4,.12,.51,.81,.02,.89Z"
    />
    <path
      fill="#56a8de"
      d="M40.58,79.53c-1.74-.51-3.45-1.22-4.96-2.23-.74-.49-1.44-1.05-2.06-1.69-.17-.18-.33-.36-.48-.56-3.22,.06-6.45,.11-9.67,.17-5.33,.1-10.95-.24-16.4,.15,5-7.67,9.69-15.57,14.37-23.45-.54-.12-1.05-.37-1.48-.72-.6-.49-1-1.14-1.27-1.85-.25-.29-.45-.63-.57-.98-.03-.1-.05-.2-.07-.3-5.62,9.22-11.26,18.45-16.37,27.93-.01,.02-.02,.04-.03,.06-.02,0-.04,0-.07,.01-1.88,.37-2.09,3.56-.2,3.88,6.98,1.15,14.7,.25,21.84,.16,6.21-.08,12.42-.18,18.63-.27-.4-.1-.81-.2-1.2-.32Z"
    />
    <path
      fill="#56a8de"
      d="M76.78,43.57c-.53,.97-1.13,1.9-1.79,2.79-.38,.52-.87,1.18-1.44,1.68,5.44,8.74,10.86,17.55,16.63,26.06-9.41,.12-18.82,.28-28.23,.45-1.88,2.18-4.1,4.02-6.76,5.09,12.18-.18,24.37-.35,36.56-.6,.61-.01,1.1-.21,1.49-.51,.13,.18,.25,.36,.38,.54,1.79-.32,3.59-.58,5.4-.73-.03-.08-.06-.15-.1-.23-7.04-11.72-14.77-23.02-22.12-34.54Z"
    />
    <path
      fill="#56a8de"
      d="M60.51,74.58s-.02,0-.02,0c-1.37,1.32-2.95,2.43-4.66,3.28-.22,.13-.44,.27-.66,.4-.09,.07-.18,.14-.28,.21-.11,.08-.21,.1-.31,.1-.11,.06-.21,.12-.32,.17-.22,.11-.45,.21-.68,.32,.29-.08,.59-.14,.88-.24,2.38-.83,4.37-2.4,6.06-4.24Z"
    />
    <polygon
      fill="#1e1e1c"
      points="42.57 20.9 40.39 20.9 40.1 20.9 40.07 20.9 40.07 20.95 40.07 21.37 40.07 23.37 42.57 23.37 42.57 20.9"
    />
    <rect fill="#1e1e1c" x="43.34" y="20.9" width="2.5" height="2.47" />
    <rect fill="#1e1e1c" x="46.61" y="20.9" width="2.5" height="2.47" />
    <rect fill="#1e1e1c" x="49.88" y="20.9" width="2.5" height="2.47" />
    <polygon
      fill="#1e1e1c"
      points="55.65 22.98 55.65 20.9 55.16 20.9 53.15 20.9 53.15 21.76 53.15 22.49 53.15 23.37 55.65 23.37 55.65 22.98"
    />
    <polygon
      fill="#1e1e1c"
      points="36.03 26.61 36.03 26.52 36.03 24.13 33.52 24.13 33.52 26.61 35.97 26.61 36.03 26.61"
    />
    <polygon
      fill="#1e1e1c"
      points="39.3 24.13 38.15 24.13 37.71 24.13 36.8 24.13 36.8 25.39 36.8 26.35 36.8 26.61 39.3 26.61 39.3 24.13"
    />
    <rect fill="#1e1e1c" x="40.07" y="24.13" width="2.5" height="2.47" />
    <rect fill="#1e1e1c" x="43.34" y="24.13" width="2.5" height="2.47" />
    <rect fill="#1e1e1c" x="46.61" y="24.13" width="2.5" height="2.47" />
    <rect fill="#1e1e1c" x="49.88" y="24.13" width="2.5" height="2.47" />
    <polygon
      fill="#1e1e1c"
      points="55.65 26 55.65 25.77 55.65 24.13 53.15 24.13 53.15 26.61 55.65 26.61 55.65 26"
    />
    <polygon
      fill="#1e1e1c"
      points="58.01 26.61 58.92 26.61 58.92 25.53 58.92 24.75 58.92 24.13 58.54 24.13 57.18 24.13 56.42 24.13 56.42 25.01 56.42 26.37 56.42 26.61 57.03 26.61 58.01 26.61"
    />
    <polygon
      fill="#1e1e1c"
      points="60.63 26.61 61.08 26.61 62.19 26.61 62.19 24.13 59.69 24.13 59.69 25.99 59.69 26.61 60.08 26.61 60.63 26.61"
    />
    <polygon
      fill="#1e1e1c"
      points="32.75 27.37 30.82 27.37 30.4 27.37 30.25 27.37 30.25 27.62 30.25 28.09 30.25 29.84 32.75 29.84 32.75 27.37"
    />
    <polygon
      fill="#1e1e1c"
      points="34.67 29.84 36.03 29.84 36.03 27.62 36.03 27.37 35.46 27.37 33.52 27.37 33.52 27.42 33.52 27.87 33.52 29.84 33.95 29.84 34.67 29.84"
    />
    <rect fill="#1e1e1c" x="36.8" y="27.37" width="2.5" height="2.47" />
    <rect fill="#1e1e1c" x="40.07" y="27.37" width="2.5" height="2.47" />
    <rect fill="#1e1e1c" x="43.34" y="27.37" width="2.5" height="2.47" />
    <rect fill="#1e1e1c" x="46.61" y="27.37" width="2.5" height="2.47" />
    <rect fill="#1e1e1c" x="49.88" y="27.37" width="2.5" height="2.47" />
    <rect fill="#1e1e1c" x="53.15" y="27.37" width="2.5" height="2.47" />
    <rect fill="#1e1e1c" x="56.42" y="27.37" width="2.5" height="2.47" />
    <polygon
      fill="#1e1e1c"
      points="62.1 29.84 62.19 29.84 62.19 27.37 60.92 27.37 60.55 27.37 59.69 27.37 59.69 29.84 61.97 29.84 62.1 29.84"
    />
    <polygon
      fill="#1e1e1c"
      points="64.79 29.84 65.47 29.84 65.47 27.37 62.96 27.37 62.96 29.84 64.66 29.84 64.79 29.84"
    />
    <polygon
      fill="#1e1e1c"
      points="30.63 33.08 32.28 33.08 32.7 33.08 32.75 33.08 32.75 32.99 32.75 31.99 32.75 30.6 30.25 30.6 30.25 33.08 30.53 33.08 30.63 33.08"
    />
    <polygon
      fill="#1e1e1c"
      points="36.03 30.6 34.21 30.6 33.53 30.6 33.52 30.6 33.52 30.61 33.52 31.73 33.52 33.08 36.03 33.08 36.03 30.6"
    />
    <rect fill="#1e1e1c" x="36.8" y="30.6" width="2.5" height="2.47" />
    <rect fill="#1e1e1c" x="40.07" y="30.6" width="2.5" height="2.47" />
    <rect fill="#1e1e1c" x="43.34" y="30.6" width="2.5" height="2.47" />
    <rect fill="#1e1e1c" x="46.61" y="30.6" width="2.5" height="2.47" />
    <rect fill="#1e1e1c" x="49.88" y="30.6" width="2.5" height="2.47" />
    <rect fill="#1e1e1c" x="53.15" y="30.6" width="2.5" height="2.47" />
    <rect fill="#1e1e1c" x="56.42" y="30.6" width="2.5" height="2.47" />
    <polygon
      fill="#1e1e1c"
      points="62.19 31.52 62.19 30.6 62 30.6 59.69 30.6 59.69 33.08 62.19 33.08 62.19 31.52"
    />
    <polygon
      fill="#1e1e1c"
      points="64.14 33.08 64.19 33.08 65.47 33.08 65.47 30.6 64.7 30.6 64.3 30.6 62.96 30.6 62.96 31.21 62.96 33.08 63.28 33.08 64.14 33.08"
    />
    <rect fill="#1e1e1c" x="26.98" y="33.84" width="2.5" height="2.47" />
    <polygon
      fill="#1e1e1c"
      points="31.11 36.31 32.75 36.31 32.75 33.84 32.24 33.84 32.04 33.84 30.25 33.84 30.25 36.31 30.74 36.31 31.11 36.31"
    />
    <rect fill="#1e1e1c" x="33.52" y="33.84" width="2.5" height="2.47" />
    <rect fill="#1e1e1c" x="36.8" y="33.84" width="2.5" height="2.47" />
    <rect fill="#1e1e1c" x="40.07" y="33.84" width="2.5" height="2.47" />
    <rect fill="#1e1e1c" x="43.34" y="33.84" width="2.5" height="2.47" />
    <rect fill="#1e1e1c" x="46.61" y="33.84" width="2.5" height="2.47" />
    <rect fill="#1e1e1c" x="49.88" y="33.84" width="2.5" height="2.47" />
    <rect fill="#1e1e1c" x="53.15" y="33.84" width="2.5" height="2.47" />
    <rect fill="#1e1e1c" x="56.42" y="33.84" width="2.5" height="2.47" />
    <rect fill="#1e1e1c" x="59.69" y="33.84" width="2.5" height="2.47" />
    <polygon
      fill="#1e1e1c"
      points="64.17 36.31 64.96 36.31 65.47 36.31 65.47 35.18 65.47 33.84 64.62 33.84 63.98 33.84 62.96 33.84 62.96 36.31 63.8 36.31 64.17 36.31"
    />
    <polygon
      fill="#1e1e1c"
      points="67.08 36.31 68.74 36.31 68.74 33.84 66.23 33.84 66.23 36.31 66.68 36.31 67.08 36.31"
    />
    <polygon
      fill="#1e1e1c"
      points="29.37 39.55 29.48 39.55 29.48 39.35 29.48 38.38 29.48 37.07 26.98 37.07 26.98 39.55 28.78 39.55 29.37 39.55"
    />
    <polygon
      fill="#1e1e1c"
      points="32.75 37.07 30.74 37.07 30.28 37.07 30.25 37.07 30.25 37.11 30.25 38.05 30.25 39.55 32.75 39.55 32.75 37.07"
    />
    <rect fill="#1e1e1c" x="33.52" y="37.07" width="2.5" height="2.47" />
    <rect fill="#1e1e1c" x="36.8" y="37.07" width="2.5" height="2.47" />
    <rect fill="#1e1e1c" x="40.07" y="37.07" width="2.5" height="2.47" />
    <rect fill="#1e1e1c" x="43.34" y="37.07" width="2.5" height="2.47" />
    <rect fill="#1e1e1c" x="46.61" y="37.07" width="2.5" height="2.47" />
    <rect fill="#1e1e1c" x="49.88" y="37.07" width="2.5" height="2.47" />
    <rect fill="#1e1e1c" x="53.15" y="37.07" width="2.5" height="2.47" />
    <rect fill="#1e1e1c" x="56.42" y="37.07" width="2.5" height="2.47" />
    <rect fill="#1e1e1c" x="59.69" y="37.07" width="2.5" height="2.47" />
    <polygon
      fill="#1e1e1c"
      points="65.47 38.47 65.47 37.07 64.84 37.07 62.96 37.07 62.96 39.55 65.47 39.55 65.47 38.47"
    />
    <polygon
      fill="#1e1e1c"
      points="68.32 39.55 68.74 39.55 68.74 37.07 68.62 37.07 68.48 37.07 66.94 37.07 66.67 37.07 66.35 37.07 66.23 37.07 66.23 37.32 66.23 39.55 68.23 39.55 68.32 39.55"
    />
    <polygon
      fill="#1e1e1c"
      points="29.48 42.78 29.48 40.31 29.07 40.31 28.32 40.31 26.98 40.31 26.98 42.52 26.98 42.78 28.23 42.78 29.48 42.78"
    />
    <rect fill="#1e1e1c" x="30.25" y="40.31" width="2.5" height="2.47" />
    <rect fill="#1e1e1c" x="33.52" y="40.31" width="2.5" height="2.47" />
    <rect fill="#1e1e1c" x="40.07" y="40.31" width="2.5" height="2.47" />
    <rect fill="#1e1e1c" x="43.34" y="40.31" width="2.5" height="2.47" />
    <rect fill="#1e1e1c" x="46.61" y="40.31" width="2.5" height="2.47" />
    <rect fill="#1e1e1c" x="49.88" y="40.31" width="2.5" height="2.47" />
    <rect fill="#1e1e1c" x="53.15" y="40.31" width="2.5" height="2.47" />
    <rect fill="#1e1e1c" x="56.42" y="40.31" width="2.5" height="2.47" />
    <rect fill="#1e1e1c" x="62.96" y="40.31" width="2.5" height="2.47" />
    <polygon
      fill="#1e1e1c"
      points="68.74 40.35 68.74 40.31 68.71 40.31 66.23 40.31 66.23 42.78 68.74 42.78 68.74 40.35"
    />
    <polygon
      fill="#1e1e1c"
      points="29.48 46.02 29.48 43.54 27.99 43.54 26.98 43.54 26.98 46.02 27.31 46.02 29.48 46.02"
    />
    <rect fill="#1e1e1c" x="30.25" y="43.54" width="2.5" height="2.47" />
    <rect fill="#1e1e1c" x="43.34" y="43.54" width="2.5" height="2.47" />
    <rect fill="#1e1e1c" x="46.61" y="43.54" width="2.5" height="2.47" />
    <rect fill="#1e1e1c" x="49.88" y="43.54" width="2.5" height="2.47" />
    <rect fill="#1e1e1c" x="53.15" y="43.54" width="2.5" height="2.47" />
    <rect fill="#1e1e1c" x="66.23" y="43.54" width="2.5" height="2.47" />
    <polygon
      fill="#1e1e1c"
      points="29.48 46.78 27.13 46.78 26.98 46.78 26.98 47.37 26.98 49.25 29.48 49.25 29.48 46.78"
    />
    <rect fill="#1e1e1c" x="30.25" y="46.78" width="2.5" height="2.47" />
    <rect fill="#1e1e1c" x="33.52" y="46.78" width="2.5" height="2.47" />
    <rect fill="#1e1e1c" x="40.07" y="46.78" width="2.5" height="2.47" />
    <rect fill="#1e1e1c" x="43.34" y="46.78" width="2.5" height="2.47" />
    <rect fill="#1e1e1c" x="46.61" y="46.78" width="2.5" height="2.47" />
    <rect fill="#1e1e1c" x="49.88" y="46.78" width="2.5" height="2.47" />
    <rect fill="#1e1e1c" x="53.15" y="46.78" width="2.5" height="2.47" />
    <rect fill="#1e1e1c" x="56.42" y="46.78" width="2.5" height="2.47" />
    <rect fill="#1e1e1c" x="62.96" y="46.78" width="2.5" height="2.47" />
    <rect fill="#1e1e1c" x="66.23" y="46.78" width="2.5" height="2.47" />
    <rect fill="#1e1e1c" x="66.23" y="50.01" width="2.5" height="2.47" />
    <rect fill="#1e1e1c" x="26.98" y="50.01" width="2.5" height="2.47" />
    <rect fill="#1e1e1c" x="30.25" y="50.01" width="2.5" height="2.47" />
    <rect fill="#1e1e1c" x="33.52" y="50.01" width="2.5" height="2.47" />
    <rect fill="#1e1e1c" x="36.8" y="50.01" width="2.5" height="2.47" />
    <rect fill="#1e1e1c" x="40.07" y="50.01" width="2.5" height="2.47" />
    <rect fill="#1e1e1c" x="43.34" y="50.01" width="2.5" height="2.47" />
    <rect fill="#1e1e1c" x="46.61" y="50.01" width="2.5" height="2.47" />
    <rect fill="#1e1e1c" x="49.88" y="50.01" width="2.5" height="2.47" />
    <rect fill="#1e1e1c" x="53.15" y="50.01" width="2.5" height="2.47" />
    <rect fill="#1e1e1c" x="56.42" y="50.01" width="2.5" height="2.47" />
    <rect fill="#1e1e1c" x="59.69" y="50.01" width="2.5" height="2.47" />
    <rect fill="#1e1e1c" x="62.96" y="50.01" width="2.5" height="2.47" />
    <rect fill="#1e1e1c" x="26.98" y="53.25" width="2.5" height="2.47" />
    <rect fill="#1e1e1c" x="30.25" y="53.25" width="2.5" height="2.47" />
    <rect fill="#1e1e1c" x="33.52" y="53.25" width="2.5" height="2.47" />
    <rect fill="#1e1e1c" x="36.8" y="53.25" width="2.5" height="2.47" />
    <rect fill="#1e1e1c" x="43.34" y="53.25" width="2.5" height="2.47" />
    <rect fill="#1e1e1c" x="46.61" y="53.25" width="2.5" height="2.47" />
    <rect fill="#1e1e1c" x="49.88" y="53.25" width="2.5" height="2.47" />
    <rect fill="#1e1e1c" x="53.15" y="53.25" width="2.5" height="2.47" />
    <rect fill="#1e1e1c" x="59.69" y="53.25" width="2.5" height="2.47" />
    <rect fill="#1e1e1c" x="62.96" y="53.25" width="2.5" height="2.47" />
    <rect fill="#1e1e1c" x="66.23" y="53.25" width="2.5" height="2.47" />
    <rect fill="#1e1e1c" x="26.98" y="56.48" width="2.5" height="2.47" />
    <rect fill="#1e1e1c" x="30.25" y="56.48" width="2.5" height="2.47" />
    <rect fill="#1e1e1c" x="33.52" y="56.48" width="2.5" height="2.47" />
    <rect fill="#1e1e1c" x="36.8" y="56.48" width="2.5" height="2.47" />
    <rect fill="#1e1e1c" x="40.07" y="56.48" width="2.5" height="2.47" />
    <rect fill="#1e1e1c" x="56.42" y="56.48" width="2.5" height="2.47" />
    <rect fill="#1e1e1c" x="59.69" y="56.48" width="2.5" height="2.47" />
    <rect fill="#1e1e1c" x="62.96" y="56.48" width="2.5" height="2.47" />
    <rect fill="#1e1e1c" x="66.23" y="56.48" width="2.5" height="2.47" />
    <rect fill="#1e1e1c" x="30.25" y="59.72" width="2.5" height="2.47" />
    <rect fill="#1e1e1c" x="33.52" y="59.72" width="2.5" height="2.47" />
    <rect fill="#1e1e1c" x="36.8" y="59.72" width="2.5" height="2.47" />
    <rect fill="#1e1e1c" x="43.34" y="59.72" width="2.5" height="2.47" />
    <rect fill="#1e1e1c" x="46.61" y="59.72" width="2.5" height="2.47" />
    <rect fill="#1e1e1c" x="49.88" y="59.72" width="2.5" height="2.47" />
    <rect fill="#1e1e1c" x="53.15" y="59.72" width="2.5" height="2.47" />
    <rect fill="#1e1e1c" x="59.69" y="59.72" width="2.5" height="2.47" />
    <rect fill="#1e1e1c" x="62.96" y="59.72" width="2.5" height="2.47" />
    <rect fill="#1e1e1c" x="30.25" y="62.95" width="2.5" height="2.47" />
    <rect fill="#1e1e1c" x="33.52" y="62.95" width="2.5" height="2.47" />
    <rect fill="#1e1e1c" x="36.8" y="62.95" width="2.5" height="2.47" />
    <rect fill="#1e1e1c" x="40.07" y="62.95" width="2.5" height="2.47" />
    <rect fill="#1e1e1c" x="43.34" y="62.95" width="2.5" height="2.47" />
    <rect fill="#1e1e1c" x="46.61" y="62.95" width="2.5" height="2.47" />
    <rect fill="#1e1e1c" x="49.88" y="62.95" width="2.5" height="2.47" />
    <rect fill="#1e1e1c" x="53.15" y="62.95" width="2.5" height="2.47" />
    <rect fill="#1e1e1c" x="56.42" y="62.95" width="2.5" height="2.47" />
    <rect fill="#1e1e1c" x="59.69" y="62.95" width="2.5" height="2.47" />
    <rect fill="#1e1e1c" x="62.96" y="62.95" width="2.5" height="2.47" />
    <rect fill="#1e1e1c" x="33.52" y="66.19" width="2.5" height="2.47" />
    <rect fill="#1e1e1c" x="36.8" y="66.19" width="2.5" height="2.47" />
    <rect fill="#1e1e1c" x="40.07" y="66.19" width="2.5" height="2.47" />
    <polygon
      fill="#1e1e1c"
      points="45.84 68.51 45.84 66.85 45.84 66.19 43.34 66.19 43.34 68.66 45.84 68.66 45.84 68.51"
    />
    <polygon
      fill="#1e1e1c"
      points="49.11 68.66 49.11 66.19 46.61 66.19 46.61 66.73 46.61 68.66 46.94 68.66 49.11 68.66"
    />
    <rect fill="#1e1e1c" x="49.88" y="66.19" width="2.5" height="2.47" />
    <rect fill="#1e1e1c" x="53.15" y="66.19" width="2.5" height="2.47" />
    <rect fill="#1e1e1c" x="56.42" y="66.19" width="2.5" height="2.47" />
    <rect fill="#1e1e1c" x="59.69" y="66.19" width="2.5" height="2.47" />
    <polygon
      fill="#1e1e1c"
      points="39.3 71.9 39.3 71.17 39.3 70.51 39.3 69.42 36.8 69.42 36.8 70.76 36.8 71.9 37.11 71.9 39.3 71.9"
    />
    <polygon
      fill="#1e1e1c"
      points="42.57 69.42 40.07 69.42 40.07 70.86 40.07 71.51 40.07 71.9 42.57 71.9 42.57 69.42"
    />
    <rect fill="#1e1e1c" x="43.34" y="69.42" width="2.5" height="2.47" />
    <polygon
      fill="#1e1e1c"
      points="49.11 71.9 49.11 69.42 47.08 69.42 46.61 69.42 46.61 71.9 47.87 71.9 49.11 71.9"
    />
    <rect fill="#1e1e1c" x="49.88" y="69.42" width="2.5" height="2.47" />
    <rect fill="#1e1e1c" x="53.15" y="69.42" width="2.5" height="2.47" />
    <polygon
      fill="#1e1e1c"
      points="58.67 71.9 58.9 71.9 58.92 71.9 58.92 71.84 58.92 71.7 58.92 70.17 58.92 69.42 56.42 69.42 56.42 71.9 56.66 71.9 58.67 71.9"
    />
    <polygon
      fill="#1e1e1c"
      points="45.84 74.83 45.84 74.48 45.84 72.66 43.34 72.66 43.34 74.39 43.34 74.88 43.34 75.13 45.84 75.13 45.84 74.83"
    />
    <polygon
      fill="#1e1e1c"
      points="49.11 74.78 49.11 74.23 49.11 72.66 48.22 72.66 46.89 72.66 46.61 72.66 46.61 74.2 46.61 74.82 46.61 75.13 49.11 75.13 49.11 74.78"
    />
    <polygon
      fill="#1e1e1c"
      points="52.38 75.13 52.38 74.8 52.38 74.72 52.38 72.66 49.88 72.66 49.88 74.76 49.88 75.13 51.34 75.13 52.38 75.13"
    />
    <path
      fill="#1e1e1c"
      d="M22.71,38.25c-.67-.34-1.53-.35-2.23-.07-1.38,.55-1.96,2.06-2.2,3.4-.27,1.49-.33,3.02-.24,4.54,.02,.33,.04,.66,.08,.99,.02,.2,.05,.41,.09,.62,.09,.56,.22,1.12,.42,1.65,.27,.71,.67,1.36,1.27,1.85,.43,.35,.94,.59,1.48,.72,.6,.14,1.23,.12,1.79-.11-.71,6.95,1.99,14.08,7.04,18.95,.71,.68,1.46,1.31,2.25,1.87-.33-.03-.7,.32-.48,.7,.34,.6,.69,1.18,1.11,1.71,.15,.19,.31,.38,.48,.56,.62,.64,1.32,1.19,2.06,1.69,1.51,1.01,3.22,1.71,4.96,2.23,.4,.12,.8,.22,1.2,.32,1.31,.31,2.64,.52,3.97,.67,.13,.01,.26,.03,.39,.05,.27,.03,.53,.04,.8,.06,2.02,.16,4.06,.13,6.05-.29,.77-.16,1.49-.41,2.19-.69,2.66-1.07,4.89-2.91,6.76-5.09,.34-.39,.66-.79,.97-1.2,2.63-3.41,4.72-7.21,6.24-11.22,1.63-4.29,2.55-8.83,2.77-13.41,.59,.03,1.13-.26,1.61-.68,.57-.5,1.06-1.16,1.44-1.68,.66-.89,1.27-1.82,1.79-2.79,.32-.59,.62-1.19,.87-1.82,.64-1.62,.93-3.38,.65-5.11-.23-1.4-1-2.95-2.47-3.39-.67-.2-1.44-.08-2.05,.27-.09-5.09-2.79-9.97-6.97-12.95-.81-.58-1.69-1.07-2.61-1.47,.49,.04,.97,.17,1.42,.41,.26,.14,.64,0,.7-.3,.44-2.24-2.38-3.09-4.11-3.25-.81-.07-1.62-.14-2.43-.21-1.93-.16-3.87-.32-5.8-.48,.48-.2,.98-.34,1.51-.43,.49-.08,.38-.77-.02-.89-1.08-.32-2.2-.49-3.33-.54-2.74-.13-5.51,.51-7.88,1.88,.35-.52,.85-.93,1.46-1.19,.42-.18,.2-.88-.24-.83-.3,.03-.59,.08-.89,.12-2.45,.33-4.82,1-7.06,2-1.96,.87-3.81,1.96-5.51,3.3-3.95,3.12-6.83,7.45-8.27,12.24-.71,2.37-1.07,4.84-1.05,7.31Zm4.5-12.83c1.56-2.52,3.6-4.71,5.96-6.48,1.11-.83,2.31-1.56,3.55-2.2,.35-.18,.69-.36,1.05-.52,1.85-.84,3.83-1.44,5.84-1.79,.07-.01,.14-.03,.2-.04-.04,.04-.06,.09-.1,.13-.42,.51-.73,1.12-.85,1.79,0,.02,0,.03-.01,.05-.06,.35,.34,.76,.69,.5,.15-.11,.31-.2,.46-.3,2.56-1.69,5.66-2.45,8.7-2.18,.27,.02,.55,.04,.82,.08-.2,.09-.4,.19-.6,.3-.25,.13-.49,.28-.72,.45-.39,.28-.23,.82,.25,.86,.43,.04,.86,.07,1.29,.11,2.21,.19,4.43,.37,6.64,.56,.23,.02,.47,.04,.7,.06,1.02,.09,2.06,.14,3.01,.55,.48,.21,1.02,.53,1.22,1-1.01-.34-2.12-.33-3.12,.09-.26,.11-.36,.34-.33,.56,.03,.17,.13,.32,.34,.39,.13,.04,.26,.09,.39,.14,4.98,1.72,8.73,6.22,9.83,11.28,.29,1.33,.37,2.7,.27,4.05,0,.05,0,.09,0,.14-.02,.11-.03,.22-.02,.34,.01,.47,.71,.65,.94,.31,.04-.05,.06-.12,.07-.2,0-.04,0-.09,0-.13h0c-.04-.95,1.23-1.39,2-1.07,1.12,.47,1.56,1.85,1.67,2.95,.19,1.89-.35,3.71-1.2,5.39-.42,.82-.9,1.61-1.41,2.36-.44,.64-.89,1.29-1.41,1.88-.09,.11-.21,.23-.34,.36-.37,.35-.85,.68-1.31,.45-.36-.18-.75,.06-.77,.46-.27,8-2.85,15.89-7.36,22.54-.13,.18-.25,.37-.37,.56-.79,1.12-1.65,2.24-2.59,3.28-.04,.04-.07,.08-.1,.12-1.7,1.84-3.68,3.41-6.06,4.24-.29,.1-.58,.16-.88,.24-1.8,.48-3.67,.59-5.53,.52-1.9-.08-3.81-.33-5.67-.75-1.37-.31-2.72-.74-4-1.32-.51-.23-1.02-.48-1.5-.77-.82-.48-1.58-1.04-2.25-1.69,0,0-.01-.01-.02-.02-.66-.64-1.33-1.35-1.79-2.15,.47,.32,.97,.61,1.47,.89,.3,.17,.6,.33,.92,.48,.26,.12,.46-.23,.22-.38-.55-.34-1.08-.7-1.61-1.08-2.34-1.68-4.4-3.73-5.99-6.12-1.94-2.91-3.27-6.24-3.74-9.71-.26-1.94-.27-3.91,.02-5.85,.06-.4-.4-.7-.72-.4-.42,.4-.99,.51-1.55,.44-.48-.06-.96-.26-1.33-.56-.1-.08-.18-.16-.27-.25-.78-.81-1.07-2.02-1.21-3.09-.03-.26-.05-.53-.07-.79-.07-.86-.09-1.73-.04-2.6,.02-.37,.05-.74,.09-1.11,.13-1.17,.31-2.53,1.2-3.39,.31-.3,.76-.49,1.22-.52,.56-.05,1.12,.15,1.39,.7,.05,.11,.13,.17,.23,.2,.26,.08,.62-.12,.6-.43,0-.19,0-.37,0-.56-.04-1.42,.05-2.84,.26-4.24,.48-3.21,1.61-6.33,3.33-9.11Z"
    />
  </svg>
)

Cyberstalking.propsTypes = {
  fillColor: PropTypes.string,
  width: PropTypes.string,
  height: PropTypes.string,
}

Cyberstalking.defaultProps = {
  fillColor: "currentColor",
  width: "60px",
  height: "60px",
}

export { Cyberstalking }
